module.exports = __webpack_public_path__ + "img/currency.41d18931.png";